import { Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { white } from '@styles/colors'
import dayjs from 'dayjs';
import { FC } from 'react';

type SingleEmployerInfoProps = {
    employerData: any
};


const SingleEmployerInfo: FC<SingleEmployerInfoProps> = ({ employerData }) => {
    return (
        <Stack p={3} spacing={3} borderRadius='8px' bgcolor={white} direction={{ xs: 'column', sm: 'row' }} justifyContent='space-around'>
            <Stack spacing={2} alignItems='center'>
                <Typography variant="h3" fontSize="14px" fontWeight="bold">
                    Account Contact
                </Typography>
                <Typography variant="body1" fontSize="14px" >
                    {employerData?.name || '-'}
                </Typography>
            </Stack>
            <Stack spacing={2} alignItems='center'>
                <Typography variant="h3" fontSize="14px" fontWeight="bold">
                    Contact email
                </Typography>
                <Typography variant="body1" fontSize="14px" >
                    {employerData?.email || '-'}
                </Typography>
            </Stack>
            <Stack spacing={2} alignItems='center'>
                <Typography variant="h3" fontSize="14px" fontWeight="bold">
                    Contact phone #
                </Typography>
                <Typography variant="body1" fontSize="14px" >
                    {employerData?.phone || '-'}
                </Typography>
            </Stack>
            <Stack spacing={2} alignItems='center'>
                <Typography variant="h3" fontSize="14px" fontWeight="bold">
                    Location
                </Typography>
                <Typography variant="body1" fontSize="14px" >
                    {employerData?.company.s_city}, {employerData?.company.s_state}
                </Typography>
            </Stack>
            <Stack spacing={2} alignItems='center'>
                <Typography variant="h3" fontSize="14px" fontWeight="bold">
                    Last login
                </Typography>
                <Typography variant="body1" fontSize="14px" >
                    {dayjs(employerData?.last_login).format('MM/DD/YY')}
                </Typography>
            </Stack>
        </Stack>
    )
}

export default SingleEmployerInfo